angular.module('dnecom')
    .service('StorageBag', ['$cookies', function ($cookies) {

        var storage;

        // Check if local storage is available
        var isStorageAvailable = function (type) {
            try {
                var storage = window[type];
                var testVariable = '__storage_test__';
                storage.setItem(testVariable, testVariable);
                storage.removeItem(testVariable);
                return true;
            }
            catch (e) {
                return false;
            }
        };

        // Local Storage Bag
        var localStorageBag = function () {
            return {
                get: function (key) {
                    return JSON.parse(localStorage.getItem(key));
                },
                put: function (key, value) {
                    localStorage.setItem(key, JSON.stringify(value));
                }
            }
        };

        // Cookies Bag
        var cookiesBag = function () {
            return {
                get: function (key) {
                    return $cookies.getObject(key);
                },
                put: function (key, value) {
                    $cookies.putObject(key, value);
                }
            }
        };

        // Set storage to use
        if (isStorageAvailable('localStorage')) {
            storage = new localStorageBag();
        } else {
            storage = new cookiesBag();
        }

        return {
            get: function (key) {
                return storage.get(key);
            },
            put: function (key, value) {
                return storage.put(key, value);
            }
        }
    }]);